import type { TenantBrandTheme } from "../../core/types.ts";

export const biblTenantBase = {
  primary: "#00B7AE",
  secondary: "#E9FAFF",
  tertiary: "#EAFFFF",
  shadowColor: "rgba(12,188,179,0.3)",
  accent: "#2dffe6",
  gradientStart: "#08C4C8",
  gradientEnd: "#06AAAE",
  fontFamily: `NotoSans, "Noto Sans", sans-serif`,
  tabsActive: {
    background: "#E9FAFF",
    borderColor: "#00B7AE",
    color: "#00B7AE",
    shadow: "0px 1px 6px 0px rgba(222,227,234,0.6)",
  },
  radii: {
    sm: 6,
    md: 8,
    lg: 10,
    xl: 12,
    full: 9999,
  },
} satisfies TenantBrandTheme;
